import { render, staticRenderFns } from "./rankPK.vue?vue&type=template&id=31a2128a&scoped=true&"
import script from "./rankPK.vue?vue&type=script&lang=js&"
export * from "./rankPK.vue?vue&type=script&lang=js&"
import style0 from "./rankPK.vue?vue&type=style&index=0&id=31a2128a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a2128a",
  null
  
)

export default component.exports